import { PhoneIcon } from "@phosphor-icons/react/dist/csr/Phone";
import {
  MaskedFormInput,
  type MaskedFormInputProps,
} from "@volca/ui/components/ui/masked-form-input";
import { phoneNumberMask } from "@volca/ui/masks";

export type PhoneInputProps = Omit<
  MaskedFormInputProps,
  "maskOptions" | "name"
> & {
  name?: string;
  /** Hint at the reserved 555-01xx test numbers. Apps turn it on outside production. */
  testNumberHint?: boolean;
};

export const PhoneInput = ({
  value,
  onChange,
  label = "Phone Number",
  placeholder = "Phone Number",
  name = "phone_number",
  info,
  testNumberHint = false,
  ...props
}: PhoneInputProps) => {
  const testWarning = testNumberHint
    ? "You're in a test environment. Use a test number like (xxx) 555-0100 to (xxx) 555-0199."
    : undefined;

  return (
    <MaskedFormInput
      type="tel"
      role="textbox"
      inputMode="numeric"
      value={value}
      onChange={onChange}
      label={label}
      placeholder={placeholder}
      startAdornment={value ? "+1" : undefined}
      endAdornment={<PhoneIcon />}
      maskOptions={phoneNumberMask}
      name={name}
      info={info || testWarning}
      {...props}
    />
  );
};
